<template>
  <v-row :class="!hideBorderBottom && 'bb'">
    <v-col cols="5">
      <span>{{ labelWithoutLastWord }}</span>
      <span class="label-last-word">
        {{ lastWordInLabel }}
        <v-icon
          v-if="required"
          class="card-row-required uikit-icon mini-star size-mini-star error"
        />
      </span>
    </v-col>
    <v-col cols="5">
      <div class="label-text-value">{{ value }}</div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SimpleTextRow',

  props: {
    name: String,
    value: {
      type: String | Number,
      default: ''
    },
    hideBorderBottom: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    labelWithoutLastWord() {
      return this.name?.split(' ').slice(0, -1).join(' ')
    },
    lastWordInLabel() {
      return this.name?.split(' ').at(-1)
    }
  }
}
</script>

<style scoped>
.label-last-word {
  white-space: nowrap;
}

.card-row-required {
  vertical-align: top;
}
</style>
